<template>
  <main>
  <h2 class="ttl"><img src="/img/ico_mail.png" alt="メールアドレス" width="40" class="mb30"><br>{{$t('mailEdit1')}}<br>{{$t('mailEdit2')}}</h2>
  <p class="btn-normal-2 mt60"><router-link :to="{ name: 'Account' }">{{$t('toProfile')}}</router-link></p>
  </main>
</template>

<script>
export default {
  name: 'AccountEmailEditCompleted'
}
</script>
